// extracted by mini-css-extract-plugin
export var root = "N_wN";
export var wrapper = "N_wP";
export var image = "N_wQ d_w d_y d_W";
export var imageWithHeight = "N_wR";
export var crop = "N_wS";
export var round = "N_wT";
export var fixedHeight = "N_wV";